import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'
import { format } from '../../../../../common/services/date.service'

export default function TenantBasicInfoComponent ({tenantsDetails}: any) {

  return (
    <>
      <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                    <InputLabelContainer
          label="Company Name"
      />
  <InputLabelContainer
      label={tenantsDetails?.CompanyName}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="No Of Stores"
      />
  <InputLabelContainer
      label={tenantsDetails?.NoOfStores}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="No Of Wareshouses"
      />
  <InputLabelContainer
      label={tenantsDetails?.NoOfWareshouses}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Created date"
      />
  <InputLabelContainer
      label={format(tenantsDetails?.CreatedOnUtc)}
  />

                    </div>
                    <div>
                    <InputLabelContainer
          label="Modified date"
      />
  <InputLabelContainer
      label={format(tenantsDetails?.ModifiedByUtc)}
  />
                    </div>

                    
      
        </div>
      }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />

    </>
  )
}